import { Component, OnInit } from '@angular/core';
import { FrontService } from '../front.service';
import { Menu } from '../../models/menu.model';

@Component({
  selector: 'app-templates-front',
  templateUrl: './templates-front.component.html',
  styleUrls: ['./templates-front.component.css']
})
export class TemplatesFrontComponent implements OnInit {
  menus: Menu[] = [];

  constructor(private frontService: FrontService) { }

  ngOnInit() {
    this.frontService.loadMenu(this.menus);
  }

}



// WEBPACK FOOTER //
// ./src/app/front/templates-front/templates-front.component.ts